module.exports = __webpack_public_path__ + "img/news_2_1.11441517.jpg";